import { createContext, useContext, useMemo, useState } from 'react';

type RightClickMenuOpenStateContextType = {
  activeRightClickMenuIds: string[];
  setActiveRightClickMenuIds: (ids: string[]) => void;
};

const RightClickMenuOpenStateContext = createContext<RightClickMenuOpenStateContextType>({
  activeRightClickMenuIds: [],
  setActiveRightClickMenuIds: () => {},
});

export const useRightClickMenuOpenState = (): RightClickMenuOpenStateContextType => {
  const context = useContext(RightClickMenuOpenStateContext);
  if (!context) {
    throw new Error('No RightClickMenuOpenStateContext.Provider found when calling useRightClickMenuOpenState.');
  }

  return context;
};

export const RightClickMenuOpenStateProvider: React.FC<React.PropsWithChildren> = ({
  children,
}: React.PropsWithChildren) => {
  const [activeRightClickMenuIds, setActiveRightClickMenuIds] = useState<string[]>([]);

  // 毎回新しいオブジェクトを渡すと、パン・ズームで親が再レンダーされるたびに全購読者（全ノード）が再レンダーされる
  const value = useMemo(
    () => ({ activeRightClickMenuIds, setActiveRightClickMenuIds }),
    [activeRightClickMenuIds, setActiveRightClickMenuIds]
  );

  return <RightClickMenuOpenStateContext.Provider value={value}>{children}</RightClickMenuOpenStateContext.Provider>;
};
